let config = {
    buildNumber: "6431",
    cachedAPI: "https://internal-cached-gcp.api.viewlift.com",
    apiBaseUrl:"https://internal-gcp.api.viewlift.com",
    apiKey:  "WX41iaJiOw7hJW8sNbDP5JpVwmjaH6t6y3xbQUsc",
    analyticsBaseUrl:"https://analytics-api.staging-livgolfplus.viewlift.com/user-beacon", // DEPRECATED. No longer needed
    sseBaseUrl: "https://event.prod-livgolfplus.viewlift.com", // DEPRECATED. No longer needed
    wssBaseUrl: "wss://prod-ws.viewlift.com", // DEPRECATED. No longer needed
    appCMSBaseUrl: "https://appcms-gcp.asset.viewlift.com",
    buildAssetsUrl: "https://appcms-gcp.asset.viewlift.com",
    toolsUrl:"https://cms-gcp.viewlift.com",
    internalEmbedBaseURL: "https://internal-gcp.api.viewlift.com",
    paymentWSUrl: "wss://prod-ws.viewlift.com/ws",
    filesProxy: {
        directPaths: [
          '/apple-app-site-association',
          '/.well-known/apple-app-site-association',
          '/.well-known/assetlinks.json',
          '/robots.txt',
          '/ads.txt',
          '/app-ads.txt',
          '/sitemap1.xml',
          '/sitemap2.xml',
          '/sitemap3.xml',
          '/sitemap4.xml',
          '/sitemap5.xml',
          '/sitemap6.xml',
          '/sitemap7.xml',
          '/sitemap8.xml',
          '/sitemap9.xml',
          '/sitemap10.xml',
          '/offline.html',
          '/serviceWorker.js',
          '/sw.js'
        ]
      },
    env:"prod"
   }
   module.exports.config = config;
